
import { makeStateKey } from "@angular/core";

export const SITE_CONFIG_KEY = makeStateKey<string>('SITE_CONFIG');